// extracted by mini-css-extract-plugin
export default {"wrapper":"NotPhone_wrapper__zAUNa","header":"NotPhone_header__pnTZW","container":"NotPhone_container__vSdHV"};